import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatChipSet, MatChipOption } from "@angular/material/chips";
import { ChatState } from "../../../../agent-ui";
import { ChatIdleConfigBridge } from "./chat-idle-config.bridge";
import { CHAT_IDLE_DEFAULTS } from "./chat-idle-config.token";
import type { AgentIdleState } from "../../model/agent.types";

/**
 * Empty state shown in the chat messages area when there are no messages yet.
 * Reads its visual config (icon, title, subtitle, suggestions, layout) from the
 * nearest ChatIdleConfigBridge provided by ChatContainerComponent, which in turn
 * is driven by the active AgentDefinition.idleState.
 */
@Component({
  selector: "lib-chat-idle-state",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatChipSet, MatChipOption],
  templateUrl: "./chat-idle-state.component.html",
  styleUrl: "./chat-idle-state.component.scss",
})
export class ChatIdleStateComponent {
  private readonly bridge = inject(ChatIdleConfigBridge, { optional: true });

  private readonly chatState = inject(ChatState, { optional: true });

  protected get config(): Required<AgentIdleState> {
    return this.bridge?.config() ?? { ...CHAT_IDLE_DEFAULTS };
  }

  protected sendSuggestion(text: string): void {
    this.chatState?.submitInput(text);
  }
}
